import type { PeriodoCampoOpcao, PeriodoValor } from '@/shared/types/filtroPeriodo';

/**
 * Um campo só: a regra escrita diz que o Período considera a última atualização das assinaturas
 * (anotação "Regra confirmada" da tela 5). As opções Criação, Envio e Visualização que o design
 * copiou da Lista não existem nesta visão.
 */
export const CAMPOS_DO_PERIODO: readonly PeriodoCampoOpcao[] = [
  {
    key: 'ultimaAtualizacao',
    label: 'Última atualização das assinaturas',
    long: 'Última atualização das assinaturas',
  },
];

export const PERIODO_DAS_ASSINATURAS_VAZIO: PeriodoValor = {
  campo: 'ultimaAtualizacao',
  inicio: null,
  fim: null,
  preset: null,
};
